module.exports = __webpack_public_path__ + "static/media/bg-home-covid19.a6fde952.png";